// extracted by mini-css-extract-plugin
module.exports = {"trailersWrapper":"tM","trailerHeader":"tN","trailers":"tO","trailer":"tP","imgWrapper":"tQ","playWrapper":"tR","playImg":"tS","title":"tT","slipnslideArrow":"tU"};